import React, { useState } from 'react';
import './styles.css';
import { Box, InputLabel, TextField, ThemeProvider, createTheme, Button, Typography } from '@mui/material';
import CustomTextField from '../../components/CustomTextField';
import YenTextField from '../../components/YenTextField';
import CustomCurrencyTextField from '../../components/CustomCurrencyTextField';
import DateSelector from '../../components/DateSelector';
import SelectBox from '../../components/SelectBox';
import MultiSelectPrimary from '../../components/MultiSelectPrimary';
import { colors } from '../../common/pallette/colors';
import HistoryTable from '../../components/HistoryTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Textarea from '@mui/joy/Textarea';
import FormControl from '@mui/joy/FormControl';
import FormHelperText from '@mui/joy/FormHelperText';
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import EmploymentStatusSelect from '../../components/EmploymentStatusSelect';
import DepartmentAutocomplete from '../../components/DepartmentAutocomplete';
import RegisteredPositionAutoComplete from '../../components/RegisteredPositionAutoComplete';
import LeaderShipRolesAutocomplete from '../../components/LeaderShipRolesAutocomplete';
import QualificationsAutoComplete from '../../components/QualificationsAutoComplete';
import { useTranslation } from 'react-i18next';
import { formatDate, isEmpty } from '../../common/StaticExports';

const theme = createTheme({
    components: {
        MuiStack: {
            styleOverrides: {
                root: {
                    paddingTop: '0px !important'
                }
            }
        }
    }
})

const competitionHead = [
    {
      key: '', displayName: 'Club Name',
    },
    {
        key: '', displayName: 'From year',
    },
    {
        key: '', displayName: 'To year',
    },
    {
        key: '', displayName: '',
    },
  ]

const coachingHead = [
{
    key: '', displayName: 'Club Name',
},
{
    key: '', displayName: 'From year',
},
{
    key: '', displayName: 'To year',
},
{
    key: '', displayName: '',
},
]

const AddStaffForm = (props: any) => {
    const {onCancelClick, onAddClick} = props;

    const [addCompetionCareer, setAddCompetitionCareer] = useState(false);
    const [addCoachingCareer, setAddCoachingCareer] = useState(false);
    const initialData = {
        kanjiName: '',
        katakanaName: '',
        englishName: '',
        dateOfBirth: null,
        jfaId: '',
        instructorRegistrationNumber: '',
        employmentStatus: '',
        department: [],
        licenceStart: null,
        licenceEnd: null,
        registeredPosition: [],
        jobTitle: '',
        leadershipRole: [],
        annualSalary: 0,
        qualifications: [],
        competitionCareers: [],
        coachingCareers: [],
        mainDuties: '',
    };
    const [newStaff, setNewStaff] = useState(initialData);
    const [t] = useTranslation();
    
    const updateState = ((key:any, updatedData:any) => {
        const updatedStaff = {
            ...newStaff,
            [key]: updatedData,
        };
        setNewStaff(updatedStaff);
    });

    return(
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Box className='mb20'>
                    <Typography className='standardsHeading uppercase'>New Staff Details</Typography>
                    <Box className={'addStaffForm'}>
                        <CustomTextField label={t('DC_5_KENJI_NAME')} value={newStaff?.kanjiName} manageChange={(d:any) => updateState('kanjiName', d)} errorMessage={t('REQUIRED')} isError={isEmpty(newStaff?.kanjiName)} />
                        <CustomTextField label={t('DC_5_KATAKANA_NAME')} value={newStaff?.katakanaName} manageChange={(d:any) => updateState('katakanaName', d)} errorMessage={t('REQUIRED')} isError={isEmpty(newStaff?.katakanaName)} />
                        <CustomTextField label={t('DC_5_ENGLISH_NAME')} value={newStaff?.englishName} manageChange={(d:any) => updateState('englishName', d)} />
                        <DateSelector label={t('DC_5_DOB')} dateValue={newStaff?.dateOfBirth} manageChange={(d:any) => {updateState('dateOfBirth', formatDate(d))}} isError={isEmpty(newStaff?.dateOfBirth)} errorMessage={t('REQUIRED')} />
                        <CustomTextField label={t('DC_5_JFA_ID')} value={newStaff?.jfaId} manageChange={(d:any) => updateState('jfaId', d)} />
                        <CustomTextField label={t('DC_5_IRN')} value={newStaff?.instructorRegistrationNumber} manageChange={(d:any) => updateState('instructorRegistrationNumber', d)} errorMessage={t('REQUIRED')} isError={isEmpty(newStaff?.instructorRegistrationNumber)} />
                        <EmploymentStatusSelect value={newStaff?.employmentStatus} manageSelect={(d:any) => updateState('employmentStatus', d)}/>
                        <DepartmentAutocomplete selectedValues={newStaff?.department ? newStaff?.department : []} manageSelect={(d:any) => updateState('department', d)} />
                        <DateSelector label={t('DC_5_LICENCE_START_DATE')} dateValue={newStaff?.licenceStart} manageChange={(d:any) => {updateState('licenceStart', formatDate(d))}}/>
                        <DateSelector label={t('DC_5_LICENCE_EXPIRY_DATE')} dateValue={newStaff?.licenceEnd} manageChange={(d:any) => {updateState('licenceEnd', formatDate(d))}}/>
                        <RegisteredPositionAutoComplete selectedValues={newStaff?.registeredPosition ? newStaff?.registeredPosition : []} manageSelect={(d:any) => updateState('registeredPosition', d)} />
                        <CustomTextField label={t('DC_5_JOB_TITLE')} value={newStaff?.jobTitle} manageChange={(d:any) => updateState('jobTitle', d)} errorMessage={t('REQUIRED')} isError={isEmpty(newStaff?.jobTitle)} />
                        <LeaderShipRolesAutocomplete selectedValues={newStaff?.leadershipRole ? newStaff?.leadershipRole : []} manageSelect={(d:any) => updateState('leadershipRole', d)} />
                        <CustomCurrencyTextField label={t('DC_5_ANNUAL_SALARY')} value={newStaff?.annualSalary} manageChange={(d:any) => updateState('annualSalary', d)} />
                        <QualificationsAutoComplete selectedValues={newStaff?.qualifications ? newStaff?.qualifications : []} manageSelect={(d:any) => updateState('qualifications', d)} />
                    </Box>
                    <Box className='mb20'>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography className='standardsHeading uppercase'>Competition Career</Typography>
                            <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCompetionCareer} variant='contained' size='small' onClick={() => {setAddCompetitionCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                {'Add another club'}
                            </Button>
                        </Box>
                        <Box>
                            <HistoryTable
                                data={newStaff?.competitionCareers}
                                head={competitionHead}
                                addData={addCompetionCareer}
                                updateList={(e:any) => {updateState('competitionCareers', e)}}
                                handleClick={() => setAddCompetitionCareer(false)}/>
                        </Box>
                    </Box>
                    <Box className='mb20'>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography className='standardsHeading uppercase'>Coaching Career</Typography>
                            <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addCoachingCareer} variant='contained' size='small' onClick={() => {setAddCoachingCareer(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                {'Add another organization'}
                            </Button>
                        </Box>
                        <Box>
                            <HistoryTable
                                data={newStaff?.coachingCareers}
                                head={coachingHead}
                                addData={addCoachingCareer}
                                updateList={(e:any) => {updateState('coachingCareers', e)}}
                                handleClick={() => setAddCoachingCareer(false)}/>
                        </Box>
                    </Box>
                    <Box className='mb20'>
                        <JoyCssVarsProvider>
                            <FormControl error={isEmpty(newStaff?.mainDuties)}>
                                <Textarea 
                                sx={{ borderRadius: '6px', mt: 0, width: '100%' }} 
                                value={newStaff?.mainDuties}
                                onChange={(e:any) => {updateState('mainDuties', e.target.value)}} 
                                placeholder='Main duties are...' 
                                minRows={2} maxRows={2}
                                />
                                {isEmpty(newStaff?.mainDuties) && (
                                    <FormHelperText>{t('REQUIRED')}</FormHelperText>
                                )}
                            </FormControl>
                        </JoyCssVarsProvider>
                    </Box>
                    <Box sx={{ mt: 'auto', display: 'flex', ml: 'auto' }}>
                        <Button 
                        className='smallButton closeCancelButtonStyles' 
                        variant='contained' sx={{ mr: 2 }} 
                        disableElevation disableRipple 
                        onClick={() => {onCancelClick(); setNewStaff(initialData);}}>
                            Cancel
                        </Button>
                        <Button
                         className='smallButton' 
                         variant='contained'
                         disableElevation 
                         disableRipple
                         onClick={() => {
                            onAddClick(newStaff);
                            setNewStaff(initialData);}}
                         >Add</Button>
                    </Box>
                </Box>
            </ThemeProvider>
        </React.Fragment>
    )
}

export default AddStaffForm;